import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=6f598140&"
import script from "./EditPage.vue?vue&type=script&lang=js&"
export * from "./EditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f598140')) {
      api.createRecord('6f598140', component.options)
    } else {
      api.reload('6f598140', component.options)
    }
    module.hot.accept("./EditPage.vue?vue&type=template&id=6f598140&", function () {
      api.rerender('6f598140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/Newsroom/Components/EditPage.vue"
export default component.exports